/**
 * "Copy to send" (message menu): a Transcript message loaded into the
 * composer as the whole draft, so Send sends it again — or the price or text
 * is changed first.
 */
import type { ChatMessage } from './messages';
import type { VaultItem } from './vaultItem';

/** What "Copy to send" can put into the composer: the text, and media only from our side (a fan's uploads are not in the vault). */
export function canCopyToSend(m: ChatMessage): boolean {
  return !!m.text || !!m.giphyId || (m.side === 'creator' && m.media.some((x) => /^\d+$/.test(x.id)));
}

/** The draft a copied message becomes. */
export interface ComposerFill {
  text: string;
  media: (VaultItem & { preview: boolean })[];
  price: number | null;
  giphyId: string | null;
  /** The fan's own media, which cannot be sent back (it is not in the vault). */
  skippedMedia: number;
}

/**
 * The draft that sends a Transcript message again: its text (without the
 * quote line a reply carries), our media by vault id with the free previews
 * kept, the PPV price and the GIF.
 */
export function fillFromMessage(m: ChatMessage): ComposerFill {
  const ours = m.side === 'creator';
  const media = ours ? m.media.filter((x) => /^\d+$/.test(x.id)) : [];
  return {
    text: m.text.replace(/^↪ [^\n]*\n/, ''),
    media: media.map((x) => ({ id: x.id, type: x.type, thumb: x.thumb, label: x.type, preview: !!m.ppv && x.preview })),
    price: m.ppv ? m.ppv.price : null,
    giphyId: m.giphyId,
    skippedMedia: m.media.length - media.length,
  };
}

